import { render, staticRenderFns } from "./GDialog.vue?vue&type=template&id=6643c464&scoped=true&"
import script from "./GDialog.vue?vue&type=script&lang=ts&"
export * from "./GDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GDialog.vue?vue&type=style&index=0&id=6643c464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643c464",
  null
  
)

export default component.exports